var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"soprts_in_acc_2",style:([_vm.width === 2 ? {'width': '50%'} : {'width': '33%'}])},[_c('div',{staticClass:"sports_v_l_1"},[_vm._v(" "+_vm._s(_vm.teamName)+" ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sports_v_r_1"},[_c('img',{staticStyle:{"width":"9px"},attrs:{"src":require("@/assets/img/ico/ico_secret.png")}})])
}]

export { render, staticRenderFns }